<nav class="navbar">

  <div class="nav-left">
    <span class="logo">Dance Admin</span>
  </div>

  <!-- HAMBURGER BUTTON (mobile only) -->
  <button class="menu-toggle" (click)="menuOpen = !menuOpen">
    ☰
  </button>

  <!-- NAV LINKS -->
  <div class="nav-rechts" [class.open]="menuOpen">
    <a routerLink="/students" routerLinkActive="active" (click)="menuOpen=false">Students</a>
    <a routerLink="/courses" routerLinkActive="active" (click)="menuOpen=false">Courses</a>
    <a routerLink="/visits" routerLinkActive="active" (click)="menuOpen=false">Visits</a>
    <a routerLink="/trials" routerLinkActive="active" (click)="menuOpen=false">Probestunden</a>
    <a routerLink="/displays" routerLinkActive="active" (click)="menuOpen=false">Anzeigen</a>
    <a routerLink="/registrations" routerLinkActive="active" (click)="menuOpen=false">Registration</a>
    <button
      type="button"
      (click)="logout(); menuOpen=false">
      Logout
    </button>
  </div>

</nav>